import { handleActions } from 'redux-actions';
import Immutable from 'immutable';

const OtherLabelState = Immutable.fromJS({
  otherLabel: {
    template: '',
    orderId: '',
    manufactureDate: '',
    serialNoFrom: '',
    serialNoTo: '',
    sizeType: '',
    outputFile: ''
  },
  otherLabelValidation: {
    serialNoFrom: {
      validationState: null,
      helpBlock: null
    },
    serialNoTo: {
      validationState: null,
      helpBlock: null
    },
    orderId: {
      validationState: null,
      helpBlock: null
    },
    template: {
      validationState: null,
      helpBlock: null
    },
    manufactureDate: {
      validationState: null,
      helpBlock: null
    },
    sizeType: {
      validationState: null,
      helpBlock: null
    }
  },
  alertStyle: null,
  alertMessage: null,
  templateList: []
});

const otherLabelReducer = handleActions({
  CHANGE_OTHERLABEL_VALUE: (state, { payload }) => {
    let otherLabel = state.get('otherLabel');
    return state.merge({
      otherLabel: otherLabel.set(payload.id, payload.value),
    });
  },
  BEFORE_GENERATE_OTHERLABEL: (state, { payload }) => {
    return state.merge({
      otherLabel: {
        outputFile: ''
      },
      alertStyle: null,
      alertMessage: '資料處理中，請稍後。'
    });
  },
  AFTER_GENERATE_OTHERLABEL: (state, { payload }) => {
    // change state
    return state.merge({
      otherLabel: payload.data.bean,
      otherLabelValidation: payload.data.valBean,
      alertStyle: payload.data.alertStyle,
      alertMessage: payload.data.alertMessage
    });
  },
  CLEAN_OTHERLABEL_ALERT: (state, { payload }) => {
    return state.merge({
      alertStyle: null,
      alertMessage: null,
      otherLabelValidation: {}
    })
  },
  FIND_MODELNOS_BY_SIZETYPE: (state, { payload }) => {
    return state.merge({
      templateList: payload.data
    })
  }
}, OtherLabelState);

export default otherLabelReducer;


// WEBPACK FOOTER //
// ./src/reducers/otherLabelReducer.js